export default __webpack_public_path__ + "838608a528040e40f3f51cb5b29cc3ae.png";